export default __webpack_public_path__ + "static/the_blaze-d7a88cc1d420aa4de96101a8457f172a.png";